var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"width":"800","height":"250"}}),_vm._v(" "),(_vm.monthBreakdown)?_c('sales-development-breakdown-modal',{attrs:{"filters":_vm.filters,"month":_vm.monthBreakdown}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }